/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement } from 'react';
import type { AppProps } from 'next/app';
import { SessionProvider } from 'next-auth/react';
import { NextIntlProvider } from 'next-intl';
import PlausibleProvider from 'next-plausible';
import { Provider } from 'react-redux';

import { SocialMediaMetadata } from '@components/social-media-metadata';
import { DATE_OPTIONS } from '@constants';
import { Application } from '@containers/application';
import { ContainerPasswordProtection } from '@containers/container-password-protection';
import { useStore } from '@state/store';
import { globalCss } from '@styles/global';

// Enable logs
// export function reportWebVitals(metric: any) {
//   console.log('web vitals', metric);
// }

function App({ Component, pageProps }: AppProps): ReactElement {
  const store = useStore(pageProps.initialReduxState);

  globalCss();

  return (
    <PlausibleProvider domain="versum.xyz">
      <SessionProvider session={pageProps.session} refetchInterval={5 * 60}>
        <Provider store={store}>
          <SocialMediaMetadata />

          <NextIntlProvider
            messages={pageProps.messages}
            // now={new Date(pageProps.now)}
            formats={{
              dateTime: {
                short: DATE_OPTIONS,
              },
              number: {
                precise: {
                  maximumFractionDigits: 5,
                },
              },
            }}
          >
            <ContainerPasswordProtection>
              <Application>
                <Component {...pageProps} />
              </Application>
            </ContainerPasswordProtection>
          </NextIntlProvider>
        </Provider>
      </SessionProvider>
    </PlausibleProvider>
  );
}

export default App;
